import React from "react";
import clsx from "clsx";
import styles from "./RecycledProduct.module.scss";
import RecycledProductList from "../../components/RecycledProduct/RecycledProductList";

const RecycledProduct = () => {
  return (
    <div className={clsx(styles.root)}>
      <h2>Quản lý sản phẩm tái chế</h2>
      <RecycledProductList />
    </div>
  );
};

export default RecycledProduct;
